export default Object.freeze({
    title: {
        inner:
            'Zigatext Cloud Messaging Platform for Bulk SMS, SMS Collections, eXtensible SMS, Free SMS, SMS Campaign, Ad Campaign, Birthday Messenger, SMS Forwarding, SMS Gateway, Cheap SMS Nigeria, SMS Aggregator, Bulk SMS Nigeria, Shortcode, Number Lookup, USSD, Advanced SMS Scheduler',
    },
    link: [
        {
            rel: 'icon',
            href: require('@/assets/icons/ziga-favicon-16x16.png'),
            sizes: '16x16',
            type: 'image/png',
        },
        {
            href:
                'https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800%7CShadows+Into+Light%7CPlayfair+Display:400&amp;display=swap',
            id: 'googleFonts',
            rel: 'stylesheet',
            type: 'text/css',
        },
    ],
    meta: [
        { name: 'robots', content: 'all' },
        {
            name: 'viewport',
            content:
                'width=device-width, initial-scale=1, minimum-scale=1.0, shrink-to-fit=no',
        },

        {
            name: 'keywords',
            content:
                'Zigatext, Free SMS, SMS Campaign, SMS Forwarding, Bulk SMS, SMS Gateway, SMS Aggregator, Mobile App, Mobile SMS App, Desktop SMS App, Web SMS Portal, Bulk SMS Nigeria, USSD, Number Lookup, Cloud Contact, Shortcode, eXtensible SMS, Advanced SMS Scheduler',
        },

        {
            name: 'description',
            content:
                'Zigatext Cloud Messaging Platform for Bulk SMS, Free SMS, SMS Campaign, Ad Campaign, Birthday Messenger, SMS Forwarding, SMS Gateway, Cheap SMS Nigeria, SMS Aggregator, Bulk SMS Nigeria, Shortcode, Number Lookup, USSD, SMS Newsletter, Programmable SMS, Advanced SMS Scheduler, eXtensible SMS.',
        },

        {
            name: 'language',
            content: 'English',
        },

        {
            name: 'doc-type',
            content: 'Public',
        },

        {
            name: 'doc-class',
            content: 'Completed',
        },
        {
            name: 'doc-rights',
            content: 'Public',
        },
        {
            name: 'GOOGLEBOT',
            content: 'NOARCHIVE',
        },
        {
            name: 'Revisit-After',
            content: '7 Days',
        },
        {
            name: 'robots',
            content: 'index,follow',
        },
        {
            name: 'distribution',
            content: 'Global',
        },
        {
            name: 'rating',
            content: 'Safe For Kids',
        },
        {
            name: 'rating',
            content: 'general',
        },
        {
            name: 'author',
            content: 'Kemonai Technologies',
        },
        {
            'http-equiv': 'X-UA-Compatible',
            content: 'IE=edge,chrome=1',
        },
        {
            'http-equiv': 'pragma',
            content: 'no-cache',
        },
        {
            'http-equiv': 'imagetoolbar',
            content: 'no',
        },
    ],
})